import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesTakePictureComponent} from "./sales-take-picture.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {QRCodeModule} from "angularx-qrcode";
import {WebcamModule} from "ngx-webcam";



@NgModule({
  declarations: [
    SalesTakePictureComponent,
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule,
    WebcamModule

  ],
  exports: [
    SalesTakePictureComponent
  ]
})
export class SalesTakePictureModule { }
